import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '../../../../services/authentication.service';
import { Router } from '@angular/router';
import { SharedService } from '../../shared.service';
import { ContentfulService } from '../../../../services/contentful.service';

@Component({
  selector: 'app-document-upload-warning-popup',
  templateUrl: './document-upload-warning-popup.component.html',
  styleUrl: './document-upload-warning-popup.component.less'
})
export class DocumentUploadWarningPopupComponent implements OnInit {
  backgroundImg = 'assets/images/img/registration_success_background.png';
  currentUser: any;
  locale = 'en-US';
  sponsorOnboardingCMSData: any;

  constructor(
    public dialogRef: MatDialogRef<DocumentUploadWarningPopupComponent>,
    private router: Router,
    private authenticationService: AuthenticationService,
    private sharedService: SharedService,
    private contentfulService: ContentfulService,
  ) {
    this.authenticationService.currentUser.subscribe(data => {
      this.currentUser = data;
    });
  }

  ngOnInit(): void {
    this.getLandingCMSData();
  }

  submitDetails() {
    if(this.currentUser && this.currentUser.token) {
      this.authenticationService.logoutUser();
    } else {
      this.router.navigate(['/login']);
    }
    this.dialogRef.close();
  }

  uploadDocument() {
    if(this.currentUser && this.currentUser.token) {
      this.dialogRef.close();
      this.router.navigate(['/profile']).then(() => {
        setTimeout(() => {
          const element = document.getElementById('doc-section');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 500); // Adjust delay if needed
      });
    }
  }

  getLandingCMSData() {
    this.sharedService.toggleGlobalLoader(true);
    this.contentfulService.getContent("35bdbvzhHRi3guRfwrXFmi", this.locale).subscribe(
      (data:any) => {
        this.sponsorOnboardingCMSData = data;
        this.backgroundImg = 'https:' + this.sponsorOnboardingCMSData.uploadDocumentPopupBackground.fields.file.url;
        this.sharedService.toggleGlobalLoader(false);
      }
    );
  }
}
